export const toFcpMetric = (metric) => {
    const { value } = metric;
    return {
        fcp: Math.trunc(value),
    };
};
//# sourceMappingURL=fcp.js.map